import React, { Component } from 'react'
import { Table, TableHead, TableBody, TableRow, TableContainer } from '@material-ui/core'
import MuiTableCell from '@material-ui/core/TableCell'
import { withStyles } from '@material-ui/core/styles'
// import uuid from 'uuid/v4'
// import InputGroup from '../../../../UI/Forms/InputGroup/InputGroup'
import { connect } from 'react-redux'
import Aux from '../../../../../hoc/Auxiliary/Auxiliary'
import * as actions from '../../../../../store/actions'
import withTranslate from 'react-redux-multilingual/lib/withTranslate'
import { getCurrencyNumber } from '../../../../../helpers'

const TableCell = withStyles({
  root: {
    borderBottom: 'none',
    whiteSpace: 'nowrap'
  }
})(MuiTableCell)

class BudgetTable extends Component {
  state = {
    gradeData: [],
    data: [
      {
        id: 1,
        name: 'Management',
        old_salary: 2500000,
        raise: '10',
        new_salary: 2570000,
        number_of_employee: 10,
        month: 2.14,
        bonus: 5380000
      },
      {
        id: 2,
        name: 'Senior',
        old_salary: 3500000,
        raise: '8',
        new_salary: 3570000,
        number_of_employee: 10,
        month: 2.34,
        bonus: 8380000
      },
      {
        id: 3,
        name: 'Staff',
        old_salary: 3500000,
        raise: '5',
        new_salary: 3570000,
        number_of_employee: 10,
        month: 2.34,
        bonus: 8380000
      },
      {
        id: 4,
        name: 'Junior',
        old_salary: 11000000,
        raise: '3',
        new_salary: 11300000,
        number_of_employee: 10,
        month: 2.34,
        bonus: 35000000
      }
    ],
    budgetSalary: 20000000,
    budgetBonus: 60000000,
    adjustData: [],
    checkSum: 0
  }

  //   static getDerivedStateFromProps(props, state) {
  //     if (typeof props.adjustData && typeof props.adjustData !== 'undefined') {
  //       if (props.gradeData !== state.gradeData) {
  //         if (props.adjustData.force_rank_budget.length !== 0) {
  //           let data = props.adjustData.force_rank_budget
  //           let grade = props.gradeData.map((item, key) => {
  //             return {
  //               ...item,
  //               budget: +data[key].budget_percent,
  //               amount: +data[key].budget_emp,
  //               id: item.value_list_id ? item.value_list_id : item.grade_id
  //             }
  //           })

  //           props.grade(grade, props.total)

  //           return {
  //             gradeData: props.gradeData,
  //             data: grade,
  //             CountForceRank: props.total
  //           }
  //         } else {
  //           let data = props.gradeData
  //           let grade = data.map(item => {
  //             return {
  //               ...item,
  //               budget: 0,
  //               amount: 0,
  //               id: item.value_list_id ? item.value_list_id : item.grade_id
  //             }
  //           })

  //           props.grade(grade, props.total)

  //           return {
  //             gradeData: props.gradeData,
  //             data: grade,
  //             CountForceRank: props.total
  //           }
  //         }
  //       }
  //     }
  //     return null
  //   }

  //   componentDidMount() {
  //     if (this.props.adjustData.force_rank_budget.length !== 0) {
  //       let data = []
  //       this.state.data.map(item => {
  //         data.push(item.amount)
  //         return item
  //       })
  //       const param = {
  //         // ...this.state.data,
  //         grade: data,
  //         amount_grade: this.state.CountForceRank,
  //         company_id: this.props.filterControls.company_id.value.value,
  //         form_id: this.props.filterControls.form_id.value.value,
  //         org_id: this.props.filterControls.org_id.value.value
  //       }
  //       this.props.fetchForceRankList(param)
  //     }
  //   }

  //   inputChanged = (key, id, e) => {
  //     let updateData = this.state.data.map(item => {
  //       if (item.id === id) {
  //         if (key === 'budget') {
  //           let amount = ~~(this.state.CountForceRank * ((parseInt(e.target.value) || 0) / 100))
  //           return {
  //             ...item,
  //             budget: parseInt(e.target.value) || 0,
  //             amount: amount,
  //             id: item.value_list_id ? item.value_list_id : item.grade_id
  //           }
  //         } else if (key === 'amount') {
  //           return {
  //             ...item,
  //             amount: parseInt(e.target.value) || 0,
  //             id: item.value_list_id ? item.value_list_id : item.grade_id
  //           }
  //         }
  //       } else {
  //         return item
  //       }
  //       return item
  //     })
  //     this.props.grade(updateData, this.state.CountForceRank)
  //     this.setState({
  //       data: updateData
  //     })
  //   }

  //   sumBudget = () => {
  //     let sum = 0
  //     this.state.data.map(item => {
  //       sum = sum + item.budget
  //       return item
  //     })
  //     return `${sum} (%)`
  //   }

  sumTable = name => {
    let sum = 0
    this.props.headerData.head_table.map(item => {
      sum = sum + +item[name]
      return item
    })
    return `${sum.toFixed(2)}`
  }

  checkBudget = name => {
    let sum = 0
    if (name === 'new_salary') {
      sum = +this.props?.headerData?.head_table[0].budget_salary - this.sumTable('new_salary')
    } else if (name === 'bonus') {
      sum = +this.props?.headerData?.head_table[0].budget_bonus - this.sumTable('bonus')
    }
    return `${sum}`
  }

  render() {
    return (
      <Aux>
        <TableContainer>
          {this.state.data.length > 0 && this.props?.headerData?.head_table ? (
            <Table size='small'>
              <TableHead>
                <TableRow>
                  <TableCell align='center'>&nbsp;</TableCell>
                  <TableCell align='center'>&nbsp;</TableCell>
                  <TableCell align='center' style={{ fontWeight: 'bold', color: '#3c91dc' }}>
                    {this.props.translate('budget')} {this.props.translate('salary')}
                  </TableCell>
                  <TableCell align='center' style={{ fontWeight: 'bold', color: '#3c91dc' }}>
                    {getCurrencyNumber(+this.props?.headerData?.head_table[0].budget_salary, 2)}
                  </TableCell>
                  <TableCell align='center'>&nbsp;</TableCell>
                  <TableCell align='center' style={{ fontWeight: 'bold', color: '#3c91dc' }}>
                    {this.props.translate('budget')} {this.props.translate('bonus')}
                  </TableCell>
                  <TableCell align='center' style={{ fontWeight: 'bold', color: '#3c91dc' }}>
                    {getCurrencyNumber(+this.props?.headerData?.head_table[0].budget_bonus, 2)}
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableHead>
                <TableRow>
                  <TableCell align='center'>&nbsp;</TableCell>
                  <TableCell align='center' style={{ fontWeight: 'bold' }}>
                    {this.props.translate('old')} {this.props.translate('salary')}
                  </TableCell>
                  <TableCell align='center' style={{ fontWeight: 'bold' }}>
                    {this.props.translate('raiseReverse')}
                  </TableCell>
                  <TableCell align='center' style={{ fontWeight: 'bold' }}>
                    {this.props.translate('newSalary')}
                  </TableCell>
                  <TableCell align='center' style={{ fontWeight: 'bold' }}>
                    {this.props.translate('numberOfEmployee')}
                  </TableCell>
                  <TableCell align='center' style={{ fontWeight: 'bold' }}>
                    {this.props.translate('month')}
                  </TableCell>
                  <TableCell align='center' style={{ fontWeight: 'bold' }}>
                    {this.props.translate('bonus')}
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {this.props.headerData.head_table.map(row => (
                  <TableRow key={row.id}>
                    <TableCell align='flex-start'>{row.name}:</TableCell>
                    <TableCell align='center'>{getCurrencyNumber(+row.old_salary, 2)}</TableCell>
                    <TableCell align='center'>{row['%raise']}</TableCell>
                    <TableCell align='center'>{getCurrencyNumber(+row.new_salary, 2)}</TableCell>
                    <TableCell align='center'>{row.number_of_employee}</TableCell>
                    <TableCell align='center'>{row.month}</TableCell>
                    <TableCell align='center'>{getCurrencyNumber(+row.bonus, 2)}</TableCell>
                  </TableRow>
                ))}
                <TableRow>
                  <TableCell align='flex-start' style={{ fontWeight: 'bold', color: '#3c91dc' }}>
                    Total:
                  </TableCell>
                  <TableCell align='center' style={{ fontWeight: 'bold', color: '#3c91dc' }}>
                    {getCurrencyNumber(+this.sumTable('old_salary'), 2)}
                  </TableCell>
                  <TableCell align='center'></TableCell>
                  <TableCell align='center' style={{ fontWeight: 'bold', color: '#3c91dc' }}>
                    {getCurrencyNumber(+this.sumTable('new_salary'), 2)}
                  </TableCell>
                  <TableCell align='center' style={{ fontWeight: 'bold', color: '#3c91dc' }}>
                    {this.sumTable('number_of_employee')}
                  </TableCell>
                  <TableCell align='center' style={{ fontWeight: 'bold', color: '#3c91dc' }}>
                    {getCurrencyNumber(+this.sumTable('bonus') / +this.sumTable('old_salary'), 2)}
                  </TableCell>
                  <TableCell align='center' style={{ fontWeight: 'bold', color: '#3c91dc' }}>
                    {getCurrencyNumber(this.sumTable('bonus'), 2)}
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell align='flex-start'></TableCell>
                  <TableCell align='center' style={{ fontWeight: 'bold' }}>
                    {this.props.translate('budget')} {this.props.translate('difference')}:
                  </TableCell>
                  <TableCell align='center'></TableCell>
                  <TableCell
                    align='center'
                    style={
                      this.checkBudget('new_salary') < 0
                        ? { fontWeight: 'bold', color: 'red' }
                        : null
                    }>
                    {getCurrencyNumber(+this.checkBudget('new_salary'), 2)}
                  </TableCell>
                  <TableCell align='center'></TableCell>
                  <TableCell align='center'></TableCell>
                  <TableCell
                    align='center'
                    style={
                      this.checkBudget('bonus') < 0 ? { fontWeight: 'bold', color: 'red' } : null
                    }>
                    {getCurrencyNumber(+this.checkBudget('bonus'), 2)}
                  </TableCell>
                </TableRow>
              </TableBody>
            </Table>
          ) : null}
        </TableContainer>
      </Aux>
    )
  }
}

const mapStateToProps = state => {
  return {}
}

const mapDispatchToProps = dispatch => {
  return {
    fetchForceRankList: param => dispatch(actions.fetchReStoreHorizontalForceRankList(param))
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(withTranslate(BudgetTable))
